<template>
    <div>
        <div
            :class="`analytics-pdf__serviceV2 guestbook-page page-${(chunkIndex + 1) % 2 === 0 ? 'even' : 'odd'}`"
            v-for="(entries, chunkIndex) in pagedEntries"
            :key="chunkIndex"
        >
            <div class="guestbook-page-content">
                <div class="guestbook-section-header">
                    <div class="analytics-pdf__header-left">
                        <h1 class="analytics-pdf__title__serviceV2 font-weight-black">
                            <template v-if="hasMessages">Notes from Loved Ones</template>
                            <template v-else>Guestbook Signatures</template>
                        </h1>
                        <p class="analytics-pdf__sub-header">
                            <template v-if="hasMessages"
                                >Here are a few memories written in memory of
                                {{ $props.tributeNameFirst | startCase }} from people watching the stream.</template
                            >
                            <template v-else
                                >These loved ones joined to honor {{ $props.tributeNameFirst | startCase }}'s
                                memory</template
                            >
                        </p>
                    </div>
                </div>
                <div class="analytics-pdf__guestbook-entries">
                    <div v-for="(entry, index) in entries" class="guestbook-entry" :key="entry.id">
                        <div class="guestbook-entry-header">
                            <!-- <span>{{ index + 1}}</span> -->
                            <template v-if="entry.templateType.startsWith('name')">
                                <span class="guestbook-signer">
                                    <template v-if="entry.fullName">{{ entry.fullName || `` }}</template>
                                    <template v-else-if="entry.firstName || entry.lastName">{{
                                        `${entry.firstName ? entry.firstName : ''} ${
                                            entry.lastName ? entry.lastName : ''
                                        }`
                                    }}</template>
                                    <template v-else>Anonymous</template>
                                </span>
                                <span v-if="entry.templateType.includes('location')">
                                    <span v-if="entry.userCity || entry.city"
                                        >{{ entry.userCity || entry.city }}{{ entry.userState || entry.regionCode ? ', ' : '' }}</span
                                    >
                                    <span v-if="entry.userState || entry.regionCode">{{ entry.userState || entry.regionCode }}</span>
                                </span>
                                <div v-if="entry.templateType.includes('email')">
                                    {{ entry.email }}
                                </div>
                            </template>

                            <template v-else-if="entry.templateType.startsWith('email')">
                                <span class="guestbook-signer">
                                    <template v-if="entry.email">{{ entry.email }}</template>
                                </span>
                            </template>
                            <template v-else>
                                <span class="guestbook-signer"> Anonymous </span>
                                <span v-if="entry.templateType.includes('location')">
                                    <span v-if="entry.userCity"
                                        >{{ entry.userCity }}{{ entry.userState ? ', ' : '' }}</span
                                    >
                                    <span v-if="entry.userState">{{ entry.userState }}</span>
                                </span>
                            </template>
                        </div>
                        <!-- <article>len: {{ entry.message.length }} / lines: {{ Math.ceil(entry.message.length / 67) }}</article> -->
                        <article :class="{ 'no-message': !entry.message }" v-if="hasMessages">
                            {{ entry.message || 'This guest signed without leaving a message' }}
                        </article>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { forEach, cloneDeep, filter, startCase } from 'lodash';
import { GUESTBOOK_RESPONSE_STATUSES } from '@/constants';

const rowPixelHeight = 24;
const headerPixelHeight = 30;
const headerWithEmailPixelHeight = headerPixelHeight + rowPixelHeight;
const bottomPixelMargin = 30;
const rowLengthInCharacters = 67;
const maxPageHeightInPixels = 1100;
export default {
    props: {
        guestbookEntries: {
            type: Array,
            default() {
                return [];
            },
        },
        tributeNameFirst: {
            type: String,
            required: true,
        },
    },
    computed: {
        // We want to know if these are just "check ins" or have actual notes to display
        hasMessages() {
            return filter(this.$props.guestbookEntries, entry => entry.message?.length).length > 0;
        },
        // A rough pagination of results based on rough heights and max page height
        // Once the collection is full then move onto the next page.
        // This seems a little brittle, in that changing font-sizes could break the layout
        // but doing it this way ensures that no entries are lost to the margins and we maintain a clean layout
        pagedEntries() {
            let pages = [];
            let currentPageHeight = 0;
            let currentPage = [];

            const acceptableStatuses = [GUESTBOOK_RESPONSE_STATUSES.UNKNOWN, GUESTBOOK_RESPONSE_STATUSES.SAFE];
            const filteredEntries = this.$props.guestbookEntries.filter(r =>
                acceptableStatuses.includes(r.moderatedStatus),
            );

            // console.log(':::: Have %s entires to display', this.$props.guestbookEntries.length);
            forEach(filteredEntries, (entry, index) => {
                let rows = Math.ceil((entry.message?.length || 0) / rowLengthInCharacters);

                let templateParts = [];
                if (entry.fullName || entry.nameFirst || entry.lastName) {
                    templateParts.push('name');
                }
                if (entry.email?.length) {
                    templateParts.push('email');
                }
                if (entry.userCity?.length && entry.userState?.length) {
                    templateParts.push('location');
                } else if (entry?.city?.length && entry?.regionCode?.length) {
                    templateParts.push('location');
                }
                entry.templateType = templateParts.join('-');

                // headerWithEmailPixelHeight
                if (entry.templateType.startsWith('name-email')) {
                    entry._height = rows * rowPixelHeight + headerWithEmailPixelHeight + bottomPixelMargin;
                } else {
                    entry._height = rows * rowPixelHeight + headerPixelHeight + bottomPixelMargin;
                }
                // If this entry will push the currentPage over the limit, then start a new page
                if (currentPageHeight + entry._height > maxPageHeightInPixels) {
                    // console.log('Current page is filled up');
                    // console.log('It should have %n entries', currentPage.length);
                    // console.log('rough page height is:', currentPageHeight);
                    pages.push(cloneDeep(currentPage));
                    currentPage = [];
                    currentPageHeight = 0;
                }
                if (currentPageHeight + entry._height <= maxPageHeightInPixels) {
                    currentPageHeight += entry._height;
                    currentPage.push(entry);
                }
            });
            if (currentPage.length) {
                // console.log('Current page is filled up');
                // console.log('It should have %n entries', currentPage.length);
                // console.log('rough page height is:', currentPageHeight);
                pages.push(cloneDeep(currentPage));
            }
            // console.log(pages);
            return pages;
        },
    },
    filters: {
        startCase(text) {
            if (text?.length) {
                return startCase(text);
            }
            return text;
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.guestbook-page {
    position: relative;
    &:before {
        print-color-adjust: exact;
        content: '';
        background-size: cover;
        opacity: 0.2;
        position: absolute;
        inset: 0;
    }
    &.page-odd:before {
        print-color-adjust: exact;
        background: url('/analytics-guestbook-bg-blue.webp') no-repeat center;
    }
    &.page-even:before {
        print-color-adjust: exact;
        background: url('/analytics-guestbook-bg-gray.webp') no-repeat center;
    }
}
.guestbook-page-content {
    position: relative;
}
.guestbook-section-header {
    color: #30527e;
    min-height: 110px;
}
.analytics-pdf__guestbook-entries {
    column-gap: 1.7rem;
    column-count: 2;
    column-fill: balance;
    &.three-col {
        column-count: 3;
    }
    max-height: 700px;
}
.guestbook-entry {
    display: inline-block;
    margin: 0 0 1.4em;
    width: 100%;
    break-inside: avoid;

    .guestbook-entry-header {
        gap: 8px;
        color: $medium-gray;
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;

        .guestbook-signer {
            font-weight: bold;
            color: $medium-blue;
            font-size: 1.2rem;
        }

        .guestbook-signer,
        .entry-email {
            margin-right: 6px;
        }
    }
    .guestbook-message {
        text-wrap-style: balance;
    }
    .no-message {
        font-style: italic;
    }
}
</style>
